import script from "./About-Us.vue?vue&type=script&setup=true&lang=js"
export * from "./About-Us.vue?vue&type=script&setup=true&lang=js"

import "./About-Us.vue?vue&type=style&index=0&id=6ec9a208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec9a208"]])

export default __exports__